import { render } from "./LoginView.vue?vue&type=template&id=2e8d4f60&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=2e8d4f60&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/front-digirespi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8d4f60"]])

export default __exports__